__turbopack_context__.v({
  "UiSkeleton": "skeleton-module__HK6gJa__UiSkeleton",
  "pulse": "skeleton-module__HK6gJa__pulse",
});
